'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (app) {
  app.directive('viewRefresh', function ($rootScope, $ionicHistory) {
    var views = {};
    $rootScope.$on('viewRefresh.trigger', function (e, stateId) {
      stateId && (views[stateId] = true);
    });
    return {
      restrict: 'A',
      link: function link($scope, $element, $attr) {
        var stateId = $ionicHistory.currentView().stateId;
        $scope.load = $attr.viewRefresh ? function () {
          return $scope.$eval($attr.viewRefresh);
        } : function () {};
        var unSubscribe = $scope.$on('$ionicView.afterEnter', function () {
          if (views[stateId]) {
            $scope.load();
            delete views[stateId];
          }
        });
        $scope.$on('$destroy', unSubscribe);
      }
    };
  });
  return app;
};

require('angular');

require('ionic');

; /**
   * 控制视图刷新
   */


//////////////////
// WEBPACK FOOTER
// ./src/lib/ionic1.x-common/directives/viewRefresh.js
// module id = 155
// module chunks = 0